module.exports = __webpack_public_path__ + "json/market27-0.json?8f9aad1fb0990757ebc13e93428fd53d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market27-0.json
// module id = 1263
// module chunks = 3